import axios from 'axios';
import Path from './Config';
import toast from './toast';
 
var http = axios.create({
    baseURL: Path.apiUrl, 
});

http.interceptors.request.use(function (config) {
    var token=localStorage.getItem('token');
    if(token){
     	config.headers = { 
            'Authorization': 'Bearer '+token,
            'Content-Type': 'application/x-www-form-urlencoded' 
        };
    }
    return config;
}); 
 
http.interceptors.response.use((response) => {
    if(response.data.status===200 && response.data.msg){
        toast.success(response.data.msg);
    }
    if(response.data.status===300){
        // toast.error(response.data.msg);
        localStorage.clear();
        window.location.href='/login';
    }
    return response;
},(error) => {
    if (error.message) {
        toast.error(error.message);
    }
    if(error.response && error.response.status===401){
 	    localStorage.clear();
        window.location.href='/login';
    }
});

 
export default http;

 


// WEBPACK FOOTER //
// ./src/core/Http.js